<template>
  <div>
    <Header></Header>
    <div class="magezineCon">
      <div class="top">
        <div class="title open">MAGAZINE</div>
      </div>
      <div class="center">
          <div class="con">
            <div class="m_img hvr-wobble-horizontal" v-for="item in items" :key="item.id">
                  <router-link :to="{name:'/magazine',params:{magazine:item.title}}">
                    <img :src="item.cover" alt="" />
                  </router-link>
              </div>
          </div>
        
      </div>
      <div class="bottom">
        <div class="menu">
          <div class="menuItem" v-for="item,index in array" :key="index">
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../../components/Header.vue'
export default{
  components:{
      Header
  },
  data() {
    return {
      array: ["A", "B", "C", "D", "H", "O"],
      items:[]
    };
  },
  mounted(){
    this.scrollInit()
    this.getData()
  },
  methods: {
    async getData() {
      const magazine = await this.$axios.get("magazine", {
      });
      this.items = magazine.data;
    },
    // 初始化与绑定监听事件方法
    scrollInit() {
      // 获取要绑定事件的元素
      const scrollDiv = document.getElementsByClassName("center")[0];
      scrollDiv.addEventListener('mousewheel', handler, false)
      function handler(event) {
        const detail = event.wheelDelta || event.detail;
        const moveForwardStep = 1;
        const moveBackStep = -1;
        let step = 0;
        if (detail < 0) {
          step = moveForwardStep * 50;
        } else {
          step = moveBackStep * 50;
        }
        scrollDiv.scrollLeft += step;
      }
    }
  }
};
</script>
<style scoped>
.magezineCon {
  width: 100%;
  height: 100vh;
  padding-top: 8vh;
  background-color: #000;
}
::-webkit-scrollbar {
  display: none;
}
.magezineCon .top {
  width: 100%;
  min-width: 999px;
  height: 15vh;
  border-top: #888 1px solid;
  border-bottom: #888 1px solid;
  background-color: #000;
  text-align: center;
  position: fixed;
  padding: 0 30px;
  box-sizing: border-box;
  z-index: 2;
}
.magezineCon .top .title {
  grid-area: 1 / 1 / 2 / 2;
  font-size: 5.5vw;
  line-height: calc(15vh - 2px);
  font-weight: bold;
  color: #fff;
}
@media screen and (max-width:999px){
  .magezineCon .top .title {
    font-size: 55px;
  }
}
.open {
    width: 29.3vw;
    overflow: hidden;
    display: inline-flex;
    animation: open 1s linear;
}
@media screen and (max-width:999px){
  .open {
    width: 293px;
  }
}
@keyframes open {
    from { width: 0 }
}
.magezineCon .center {
  width: 100%;
  height: fit-content;
  top: 30vh;
  position: fixed;
  overflow-x: auto;
  overflow-y: hidden;
}
.magezineCon .center .con{
  width: fit-content;
  height: fit-content;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
.magezineCon .center span{
  display: contents;
}
.magezineCon .center .con .m_img{
    width: 20vw;
    min-width: 200px;
    height: 50vh;
    display: inline-block;
    padding: 0 3vh;
    box-sizing: content-box;
}
.magezineCon .center .con .m_img img {
  width: 20vw;
  min-width: 200px;
  height: 50vh;
  object-fit: contain;
}
.magezineCon .bottom {
  width: 100%;
  min-width: 999px;
  height: 3vh;
  position: fixed;
  bottom: 3vh;
}
.magezineCon .bottom .menu {
  width: fit-content;
  height: inherit;
  margin: 0 auto;
}
.magezineCon .bottom .menu .menuItem {
  width: 3vh;
  height: 3vh;
  line-height: 3vh;
  padding: 0 1vh;
  color: #fff;
  display: inline-block;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  border-radius: 1.5vh;
}
.magezineCon .bottom .menu .menuItem:hover {
  background-color: #fff;
  color: #000;
}
.magezineCon .bottom .menu .menuItem:active {
  background-color: #fff;
  color: #000;
}
</style>


// WEBPACK FOOTER //
// src/view/pc/AllMagazine.vue